class Mob extends PIXI.Container implements UniqIdMarked{
    public name:DictNames;
    public health:number;
    public healthMax: number;
    public armor:number;
    public movementSpeed:number;
    public reloadTimeout:number;
    public attack:()=>number;
    public damage:()=>number;
    public boomRadius:number;
    public uniqId:number;
    public cell:Cell = null;
    public zombie:boolean = false;
    public price:number = 0;
    
    public dict:MobDict;
    
    public lastCellX:number;
    public lastCellY:number;
    
    public constructor(dict:MobDict) {
        super();
        this.uniqId = UniqIdGenerator.getUniq();
        this.name = dict.name;
        this.dict = dict;
        this.respawn();
    }
    
    public respawn() {
        let dict = this.dict;
        this.health = DnDUtils.getDiceGenerator(dict.health)();
        this.healthMax = this.health;
        this.armor = DnDUtils.getDiceGenerator(dict.armor)();
        this.movementSpeed = DnDUtils.getDiceGenerator(dict.movementSpeed)();
        this.reloadTimeout = DnDUtils.getDiceGenerator(dict.reloadTimeout)();
        this.attack = DnDUtils.getDiceGenerator(dict.attack);
        this.damage = DnDUtils.getDiceGenerator(dict.attack);
        this.boomRadius = DnDUtils.getDiceGenerator(dict.boomRadius)();
        this.price = DnDUtils.getDiceGenerator(dict.price)();
        this.zombie = false;
        this.lastCellX = undefined;
        this.lastCellY = undefined;
        this.cell = null;
    }
}